import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { DocumentUrl } from "../../models/cartable.model";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

export default function LoadDocument(props: any) {
  let pdfFileType = false;
  if (props.data.fileType == "PDF") {
    pdfFileType = true;
  }
  let typeFiles;
  let type;
  if (props.data.fileType == "Image") {
    typeFiles = <img src={props.data.fileUrl} className="uploadImage" alt="" />;
    type = "jpg";
  } else if (props.data.fileType == "PDF" || props.data.fileType == "Any") {
    typeFiles = (
      <PictureAsPdfOutlinedIcon
        className="uploadImageCmpIconPDF  "
        style={{ marginTop: "1vh" }}
      />
    );
    type = "pdf";
  } else if (props.data.fileType == "ZIP" || props.data.fileType == "RAR") {
    typeFiles = <FolderZipOutlinedIcon className="uploadImageCmpIcon " />;
    type = "RAR";
  } else {
    typeFiles = <InsertDriveFileOutlinedIcon className="uploadImageCmpIcon " />;
    type = "jpg";
  }
  return (
    <div className="UploadImageCmp">
      <>
        {props.data ? (
          pdfFileType ? (
            <>
              <a href={`${props.data.fileUrl!}/true`} target="_blank">
                {typeFiles}
              </a>
            </>
          ) : (
            <>
              <a href={props.data.fileUrl!} target="blank">
                <img
                  src={props.data.fileUrl!}
                  className="uploadImage  verticalImageloadDocument"
                  alt=""
                />
              </a>
            </>
          )
        ) : null}
      </>
    </div>
  );
}
